import { makeQueryClient } from '@bitez/data'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { useState } from 'react'

import { router } from './router'

/**
 * One QueryClient instance goes to two places:
 *   1. `QueryClientProvider` — wraps the tree,
 *   2. `RouterProvider context` — so route loaders can `ensureQueryData` and hit
 *      the same cache the components read.
 *
 * The provider sits ABOVE the router on purpose: loaders run before the first
 * route component renders and still need the client.
 */
export default function App() {
  const [queryClient] = useState(makeQueryClient)

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} context={{ queryClient }} />
    </QueryClientProvider>
  )
}
